import { Validators } from "@angular/forms";
import { IEquipmentTypeResponse } from "@app/shared/data-access/src/lib/resource-management/models/equipment";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import { PathIcons } from "@app/shared/static/icons/path-icons";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormSelectParams,
  IHardTable,
} from "@app/shared/ui-lib/src/lib";
import { IBaseConfig, IFormFieldFilter } from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";

export class EquipmentTypeConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.EquipmentType;

  filterTemplateColumns = "1fr";

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      params: {
        direction: "row",
        templateColumns: "1fr 1fr 1fr",
        fields: [
          {
            title: "dicTable.equipmentClass",
            name: "equipmentClass",
            type: HardFormFieldTypeEnum.Dictionary,
            params: {
              dicType: "api/v1/" + ResourceManagementEndpoints.EquipmentClass,
              validators: [Validators.required],
            } as IHardFormSelectParams,
          },
          {
            title: "dicTable.mobilityType",
            name: "mobilityType",
            type: HardFormFieldTypeEnum.Dictionary,
            params: {
              dicType:
                "api/v1/" + ResourceManagementEndpoints.EquipmentMobilityType,
              validators: [Validators.required],
            } as IHardFormSelectParams,
          },
          {
            title: "dicTable.requiresTransport",
            name: "requiresTransport",
            type: HardFormFieldTypeEnum.Select,
            value: false,
            params: {
              options: [
                { id: true, name: "base.yes" },
                { id: false, name: "base.no" },
              ],
              validators: [Validators.required],
            } as IHardFormSelectParams,
          },
        ],
      },
    },
    {
      title: "dicTable.icon",
      name: "iconUrl",
      type: HardFormFieldTypeEnum.Icon,
      params: {
        dicType: PathIcons,
      },
    } as IHardFormField<IHardFormSelectParams>,
    {
      title: "dicTable.workCenter",
      name: "workCenters",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.WorkCenter,
        multiple: true,
        validators: [Validators.required],
      } as IHardFormSelectParams,
    },
    {
      title: "dicTable.sortOrder",
      name: "sortOrder",
      type: HardFormFieldTypeEnum.Number,
      params: {
        validators: [Validators.required],
      },
    },
  ];

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig?: IHardTable<IEquipmentTypeResponse[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(9,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.class",
        name: "name",
        type: HardTableColumnTypeEnum.Parent,
        parent: "equipmentClass",
      },
      {
        title: "dicTable.mobilityType",
        name: "name",
        type: HardTableColumnTypeEnum.Parent,
        parent: "mobilityType",
      },
      {
        title: "dicTable.requiresTransport",
        name: "requiresTransport",
        type: HardTableColumnTypeEnum.Boolean,
      },
      {
        title: "dicTable.workCenter",
        name: "name",
        type: HardTableColumnTypeEnum.Parent,
        parent: "workCenter",
      },
      {
        title: "dicTable.specialParams",
        name: "propertiesCount",
        type: HardTableColumnTypeEnum.Number,
      },
      {
        title: "dicTable.equipmentCount",
        name: "equipmentCount",
        type: HardTableColumnTypeEnum.Number,
      },
      {
        title: "dicTable.icon",
        name: "iconUrl",
        type: HardTableColumnTypeEnum.Icon,
      },
    ],
  };
}
